// ===========================================
// All Notes Dialog Component
// ===========================================

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { Note } from '../../../api/notes.api';
import LessonNoteItem from './LessonNoteItem';

interface AllNotesDialogProps {
  open: boolean;
  onClose: () => void;
  lessonName: string;
  notes: Note[] | undefined;
}

export default function AllNotesDialog({
  open,
  onClose,
  lessonName,
  notes,
}: AllNotesDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>All Class Notes - {lessonName}</DialogTitle>
      <DialogContent dividers>
        {notes && notes.length > 0 ? (
          notes.map((note) => (
            <LessonNoteItem key={note.id} note={note} showFullContent />
          ))
        ) : (
          <Typography color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
            No notes found
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
